import { render, staticRenderFns } from "./ListaSimulacion.vue?vue&type=template&id=bb02be7a&"
import script from "./ListaSimulacion.vue?vue&type=script&lang=js&"
export * from "./ListaSimulacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports